import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { OfficeDataProps } from "src/models/office.model";
import { PutPayloadProps } from "src/models/service.models";
import commonUtils from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function editOfficeApproveReject(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.patch(
    API_URL.DENTAL_OFFICE.OFFICE_REJECT_APPROVE + params,
    data
  );
}

export async function getOfficeUsers(params?: OfficeDataProps) {
  return await apiCall.get(API_URL.DENTAL_OFFICE.GET_OFFICE_USERS, {
    ...params,
  });
}
export async function getPayScale() {
  return await apiCall.get(API_URL.DENTAL_OFFICE.GET_PAY_SCALE);
}
export async function getOfficeData(uuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_OFFICE.GET_OFFICE_DATA,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.get(url);
}
export async function getViewOffice(params: string) {
  return await apiCall.get(API_URL.DENTAL_OFFICE.GET_VIEW_OFFICE + params);
}
